import { render, staticRenderFns } from "./FormControlCategoryTitle.vue?vue&type=template&id=b0136cf2"
import script from "./FormControlCategoryTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlCategoryTitle.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports